<template>
<div class="container">
	<div class="header"><img :src="$store.state.config.header" class="img"></div>
	<div class="content">
		<div class="main-body">
			<div class="top-bar" :style="{backgroundColor: $store.state.config.title_color}">{{title}}</div>
			<div class="main-wrapper t-block">
				<div class="main-content">
					<div class="line-height"><span>&nbsp;</span></div>
					<div class="detail-tilte"><p>{{title}}</p></div>
					<div class="presents-box details">
	          <div class="arrow-up">&nbsp;</div>
	          <ul class="detail-votes" id="result-list">
	          	<li class="votes-item" v-for="item in data.candidates">
	          		<div class="vote-text">{{item.name}}</div>
	          		<div class="item-text-count" :style="{width:data.votes[item.candidate_id]/max*100+'%', backgroundColor: $store.state.config.progress_color}"></div>
	          		<span class="item-vote-text" v-show="$store.state.config.show_votes">{{data.votes[item.candidate_id]}}票</span>
	          		<div class="clearfix"></div>
	          	</li>
	          </ul>
	        </div>
					<div class="share-box">
	          <router-link class="share-btn" :to="{path: 'list', query: {reward_id: $route.query.reward_id, tt: $route.query.tt}}" :style="{backgroundColor: $store.state.config.button_color}">返回上页</router-link>
	          <router-link class="back-btn" :to="{path: '/', query: {tt: $route.query.tt}}" :style="{backgroundColor: $store.state.config.button_color}">查看奖项</router-link>
					</div>
					<div class="footer"><img :src="$store.state.config.footer"></div>
				</div>
			</div>	
		</div>
	</div>
	<v-loading v-show="status"></v-loading>
</div>
</template>

<script>
import {ajax} from 'jquery';

import Load from '@/components/Loading'
import shareInfo from '@/assets/js/weixinShare.js'

export default{
	name: 'result',
  components: {
    'v-loading': Load
  },
	data() {
		return{
      status: true, //loading状态
      title: '',
      data: {},
      max: 1
		}
	},
	created() {
		let that = this;

		document.body.scrollTop = 0;
		ajax({
			type: 'get',
			url: that.$store.state.Host+'/v/rewards/'+that.$route.query.reward_id+'?show_votes=1',
			success: function (res) {
		   	that.data = res;
		   	that.title = res.name;
				that.status = false;
				//计算最大值
				that.maxValue(res.votes);
		  }
		});
	},
	mounted() {
		let that = this;

    setTimeout(function() {
      // 分享调用
      shareInfo.init({title:that.$store.state.config.title,desc:that.$store.state.config.share_desc,shareURL: location.href,img:that.$store.state.config.share});
    }, 2000);
	},
	methods: {
		maxValue(data) {
			let max = 1,
					that = this;

			for(var i in data) {
				if(max < parseInt(data[i])) {
					max = parseInt(data[i]);
				}
			}

			that.max = max;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/Result.vue